function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children", "className", "dataTestId", "headingLevel", "marginBottom", "marginLeft", "marginRight", "marginTop", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef, useMemo, useRef } from 'react';
import classnames from 'classnames';
import { Negative } from "../Icon";
import Text from "../Text";
import { uniqueId } from "../../utils";
import StyledErrorSummary, { StyledErrorSummaryChildrenContainer, StyledErrorSummaryIconContainer, StyledErrorSummaryTextContainer, StyledErrorSummaryTextIconContainer } from "./styled";
import { useBrand } from "../BrandProvider";
/**
 * Documentation:
 *
 * - [Link for Windows (On-prem)](https://pages.ghe.service.group/constellation/docs/components/error-summary)
 **/
var ErrorSummary = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    dataTestId = _ref.dataTestId,
    headingLevel = _ref.headingLevel,
    _ref$marginBottom = _ref.marginBottom,
    marginBottom = _ref$marginBottom === void 0 ? '05' : _ref$marginBottom,
    _ref$marginLeft = _ref.marginLeft,
    marginLeft = _ref$marginLeft === void 0 ? 'none' : _ref$marginLeft,
    _ref$marginRight = _ref.marginRight,
    marginRight = _ref$marginRight === void 0 ? 'none' : _ref$marginRight,
    _ref$marginTop = _ref.marginTop,
    marginTop = _ref$marginTop === void 0 ? 'none' : _ref$marginTop,
    title = _ref.title,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _ref2 = useBrand() || {},
    _ref2$testAttributeNa = _ref2.testAttributeName,
    testAttributeName = _ref2$testAttributeNa === void 0 ? 'data-qa-id' : _ref2$testAttributeNa;
  var testAttributes;
  var getTestAttributes = function getTestAttributes(element) {
    var _testAttributes;
    return ((_testAttributes = testAttributes) === null || _testAttributes === void 0 ? void 0 : _testAttributes[element]) || {};
  };
  if (dataTestId) {
    testAttributes = {};
    testAttributes.default = _defineProperty({}, testAttributeName, dataTestId);
  }
  var classNames = useMemo(function () {
    return classnames('csl-error-summary', className);
  }, [className]);
  var headingId = useRef(uniqueId('csl-error-summary-heading'));
  return /*#__PURE__*/React.createElement(StyledErrorSummary, _extends({
    $marginBottom: marginBottom,
    $marginLeft: marginLeft,
    $marginRight: marginRight,
    $marginTop: marginTop,
    "aria-labelledby": headingId.current,
    className: classNames,
    ref: ref,
    role: "alert",
    tabIndex: -1
  }, getTestAttributes('default'), rest), /*#__PURE__*/React.createElement(StyledErrorSummaryTextIconContainer, {
    className: "csl-error-summary__text-icon-container"
  }, /*#__PURE__*/React.createElement(StyledErrorSummaryIconContainer, {
    className: "csl-error-summary__icon-container"
  }, /*#__PURE__*/React.createElement(Negative, {
    color: "critical",
    iconSize: "lg",
    size: "s3"
  })), /*#__PURE__*/React.createElement(StyledErrorSummaryTextContainer, {
    className: "csl-error-summary__text-container"
  }, /*#__PURE__*/React.createElement(Text, {
    "aria-level": headingLevel,
    color: "critical",
    id: headingId.current,
    role: "heading",
    size: "s3",
    weight: "bold"
  }, title))), /*#__PURE__*/React.createElement(StyledErrorSummaryChildrenContainer, {
    className: "csl-error-summary__children-container"
  }, children));
});
ErrorSummary.displayName = 'ErrorSummary';
export default ErrorSummary;